<template>
  <div class="ricerca col-24 no-padding">
    <ricerca-panel :filtri="filtriRicerca"
                   @closeRicerca="closeRicerca"
                   @changeValueOrClick="changeValueOrClick"
                   @cerca="cerca"></ricerca-panel>
  </div>
</template>

<script>
  import RicercaPanel from '@/components/ServiceComponents/RicercaPanel'
  import {bus} from '../../Bus.js'

  export default {
    name: 'Ricerca',
    components: {RicercaPanel},
    i18n: {
      messages: {
        it_IT: {
          ricerca: {
            filtri: 'Filtri',
            statoNazione: 'Stato',
            codForn: 'Codice Fornitore',
            societa: 'Società',
            stabilimento: 'Stabilimento',
            cerca: 'Cerca',
            scegli: 'Scegli...',
            numOfferta: 'Numero Offerta',
            statoAvanzamento: 'Stato Avanzamento',
            I: 'Offerta Inviata',
            S: 'Offerta Salvata',
            N: 'Nuova Offerta'
          }
        },
        fr_FR: {
          ricerca: {
            filtri: 'Filtres',
            statoNazione: 'Pays',
            codForn: 'Code du Fournisseur',
            societa: 'Société',
            stabilimento: 'Usine',
            cerca: 'Recherche',
            scegli: 'Choisir...',
            numOfferta: 'Numéro de l\'Offre',
            statoAvanzamento: 'État d\'Avancement',
            I: 'Offre Envoyée',
            S: 'Offre Enregistrée',
            N: 'Nouvelle Offre'
          }
        },
        es_ES: {
          ricerca: {
            filtri: 'Filtros',
            statoNazione: 'País',
            codForn: 'Código de Proveedor',
            societa: 'Empresa',
            stabilimento: 'Fábrica',
            cerca: 'Búsqueda',
            scegli: 'Elegir...',
            numOfferta: 'Número de Oferta',
            statoAvanzamento: 'Estado',
            I: 'Oferta Enviada',
            S: 'Oferta Guardada',
            N: 'Nueva Oferta'
          }
        },
        de_DE: {
          ricerca: {
            filtri: 'Filter',
            statoNazione: 'Land',
            codForn: 'Lieferantencode',
            societa: 'Unternehmen',
            stabilimento: 'Werk',
            cerca: 'Suche',
            scegli: 'Wählen...',
            numOfferta: 'Angebotsnummer',
            statoAvanzamento: 'Status',
            I: 'Angebot Versandt',
            S: 'Angebot Gespeichert',
            N: 'Neues Angebot'
          }
        },
        en_GB: {
          ricerca: {
            filtri: 'Filters',
            statoNazione: 'Country',
            codForn: 'Supplier Code',
            societa: 'Society',
            stabilimento: 'Establishment',
            cerca: 'Search',
            scegli: 'Choose...',
            numOfferta: 'Offer number',
            statoAvanzamento: 'Progress',
            I: 'Sent Offer',
            S: 'Saved Offer',
            N: 'New Offer'
          }
        }
      }
    },
    data () {
      return {
        codLang: sessionStorage.getItem('codLang'),
        firstLoad: true,
        codForn: '',
        codFornAdmin: {},
        filtriRicerca: {
          loading: true,
          titolo: '',
          valueSelected: {
            0: '',
            1: {},
            2: '',
            3: '',
            4: '',
            5: ''
          },
          dati: {
            0: [],
            1: [],
            2: [],
            3: [],
            5: []
          },
          filtri: [
            // Select con le country a cui è abilitato l'utente
            {
              type: 'select',
              myLabel: '',
              value: 'country',
              label: 'desc',
              key: 'country',
              onChangeOrClick: 'changeCountry',
              ifClearable: false,
              ifDisabled: false
            },
            // Select con i fornitori
            {
              type: 'select-with-object',
              myLabel: '',
              value: '',
              label: ['codForn', 'desForn'],
              key: 'codForn',
              onChangeOrClick: 'changeCodForn',
              ifClearable: false,
              ifDisabled: false,
              ifShow: false
            },
            // Select con le Società
            {
              type: 'select',
              myLabel: '',
              value: 'codSoc',
              label: 'desSoc',
              key: 'codSoc',
              onChangeOrClick: 'changeSocieta',
              ifClearable: true,
              ifDisabled: true
            },
            {
              type: 'select',
              myLabel: '',
              value: 'codMag',
              label: 'desMag',
              key: 'codMag',
              ifClearable: true,
              ifDisabled: true
            },
            {
              type: 'input',
              myLabel: '',
              ifClearable: true
            },
            {
              type: 'select',
              myLabel: '',
              value: 'codSt',
              label: 'desSt',
              key: 'codSt',
              ifClearable: true,
              ifDisabled: false
            }
          ]
        }
      }
    },
    mounted: function () {
      bus.$on('changeLanguage', () => {
        this.$set(this, 'codLang', sessionStorage.getItem('codLang'))
        this.$nextTick(() => {
          this.setTraduzioniLabel()
          this.getCountries(true)
        })
      })
      bus.$on('Header_SetCodFornAdmin', () => {
        if (localStorage.hasOwnProperty('amministrazione')) {
          this.$set(this, 'codFornAdmin', JSON.parse(localStorage.getItem('amministrazione')))
          this.$set(this, 'codForn', this.codFornAdmin.UFFACQ[this.filtriRicerca.valueSelected[0]])
        } else {
          this.$set(this, 'codFornAdmin', {})
          this.$set(this, 'codForn', '')
        }
        if (!this._inactive) {
          this.$set(this.filtriRicerca.dati, 1, [])
          this.$set(this.filtriRicerca.dati, 2, [])
          this.$set(this.filtriRicerca.dati, 3, [])
          this.$set(this.filtriRicerca.valueSelected, 1, {})
          this.$set(this.filtriRicerca.valueSelected, 2, '')
          this.$set(this.filtriRicerca.valueSelected, 3, '')
          this.$set(this.filtriRicerca.valueSelected, 4, '')
          this.$set(this.filtriRicerca.valueSelected, 5, '')
          this.$set(this.filtriRicerca.filtri[2], 'ifDisabled', true)
          this.$set(this.filtriRicerca.filtri[3], 'ifDisabled', true)

          if (this.codForn) {
            this.getSocieta()
          }
        }
      })
    },
    activated: function () {
      this.init()
    },
    methods: {
      init: function () {
        this.$nextTick(() => {
          // Se è salvata nel sessionStorage una ricerca la reimposto
          if (sessionStorage.hasOwnProperty('RdO_form')) {
            let form =  JSON.parse(sessionStorage.getItem('RdO_form'))
            this.$set(this.filtriRicerca.valueSelected, 0, form.country)
            this.$set(this, 'codForn', form.codForn)
            let fornObj = {
              codForn: form.codForn,
              desForn: ''
            }
            this.$set(this.filtriRicerca.valueSelected, 1, fornObj)
            this.$set(this.filtriRicerca.valueSelected, 2, form.codSoc)
            this.$set(this.filtriRicerca.valueSelected, 3, form.codMag)
            this.$set(this.filtriRicerca.valueSelected, 4, form.numRif)
            this.$set(this.filtriRicerca.valueSelected, 5, form.codAvanz)
          } else {
            this.$set(this.filtriRicerca.valueSelected, 0, '')
            this.$set(this.filtriRicerca.valueSelected, 1, {})
            this.$set(this.filtriRicerca.valueSelected, 2, '')
            this.$set(this.filtriRicerca.valueSelected, 3, '')
            this.$set(this.filtriRicerca.valueSelected, 4, '')
            this.$set(this.filtriRicerca.valueSelected, 5, '')
          }

          // Se esiste nel localStorage l'oggetto amministrazione lo setto
          if (localStorage.hasOwnProperty('amministrazione')) {
            this.$set(this, 'codFornAdmin', JSON.parse(localStorage.getItem('amministrazione')))
          }

          // Chiamo il servizio per la lista degli Stati a cui sono abilitato passando come parametro false (NON sto cambiando lingua)
          this.getCountries(false)

          // Chiamo il metodo per settare le traduzioni delle label nella lingua impostata
          this.setTraduzioniLabel()
        })
      },
      setTraduzioniLabel: function () {
        this.$set(this.filtriRicerca, 'titolo', this.$t('ricerca.filtri'))
        this.$set(this.filtriRicerca.filtri[0], 'myLabel', this.$t('ricerca.statoNazione'))
        this.$set(this.filtriRicerca.filtri[1], 'myLabel', this.$t('ricerca.codForn'))
        this.$set(this.filtriRicerca.filtri[2], 'myLabel', this.$t('ricerca.societa'))
        this.$set(this.filtriRicerca.filtri[3], 'myLabel', this.$t('ricerca.stabilimento'))
        this.$set(this.filtriRicerca.filtri[4], 'myLabel', this.$t('ricerca.numOfferta'))
        this.$set(this.filtriRicerca.filtri[5], 'myLabel', this.$t('ricerca.statoAvanzamento'))
      },
      closeRicerca: function () {
        this.$emit('closeRicerca')
      },
      cerca: function () {
        let form = {
          country: this.filtriRicerca.valueSelected[0],
          codForn: this.codForn,
          codSoc: this.filtriRicerca.valueSelected[2],
          codMag: this.filtriRicerca.valueSelected[3],
          numRif: this.filtriRicerca.valueSelected[4],
          codAvanz: this.filtriRicerca.valueSelected[5]
        }
        this.$emit('cerca', JSON.stringify(form))
      },
      changeValueOrClick: function (index) {
        if (this.filtriRicerca.filtri[index].hasOwnProperty('onChangeOrClick')) {
          this[this.filtriRicerca.filtri[index].onChangeOrClick]()
        }
      },
      getCountries: function (ifChangeLang) {
        this.$http.get('portale/countries', {
          params: {
            codLang: this.codLang,
            codiApp: 'WebRichiestaOfferta'
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              let data = response.body.data
              this.$set(this.filtriRicerca.dati, 0, data)
              if (data.length > 0) {
                // Se NON c'è una ricerca già salvata nel sessionStorage
                if (!sessionStorage.hasOwnProperty('RdO_form')) {
                  // Verifico se lo Stato impostato nel localStorage esiste tra quelli restituiti dal servizio delle abilitazioni
                  let flag = data.some(e => e.country === localStorage.getItem('UFFACQ_country'))
                  // Se flag = true uso lo Stato del localStorage
                  this.$set(this.filtriRicerca.valueSelected, 0, flag ? localStorage.getItem('UFFACQ_country') : data[0].country)
                }

                this.getStatiAvanzamento(ifChangeLang)
              }
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              this.filtriRicerca.loading = false
            }
          })
      },
      /*  Al momento del cambio della country vengono azzerati array e valori in modo da ricominciare
       il flusso delle funzioni dalla getFornitoreInfo
       */
      changeCountry: function () {
        this.$set(this.filtriRicerca.dati, 1, [])
        this.$set(this.filtriRicerca.dati, 2, [])
        this.$set(this.filtriRicerca.dati, 3, [])
        this.$set(this.filtriRicerca.valueSelected, 1, {})
        this.$set(this.filtriRicerca.valueSelected, 2, '')
        this.$set(this.filtriRicerca.valueSelected, 3, '')
        this.$set(this.filtriRicerca.valueSelected, 4, '')
        this.$set(this.filtriRicerca.valueSelected, 5, '')
        this.$set(this.filtriRicerca.filtri[1], 'ifDisabled', true)
        this.$set(this.filtriRicerca.filtri[2], 'ifDisabled', true)
        this.$set(this.filtriRicerca.filtri[3], 'ifDisabled', true)

        sessionStorage.removeItem('SO_form')
        sessionStorage.removeItem('SO_ordine')
        sessionStorage.removeItem('BdR_form')
        sessionStorage.removeItem('BdR_ordine')
        sessionStorage.removeItem('RdO_form')
        sessionStorage.removeItem('RdO_offerta')
        this.$store.commit('set', {key: 'RDQ_Ricerca', value: {}})
        this.$store.commit('set', {key: 'RDQ_Quotazione', value: {}})
        sessionStorage.removeItem('UFFACQ_fornitore')

        // Se esiste l'oggetto amministrazione prendo il codForn UFFACQ del nuovo Stato
        if (localStorage.hasOwnProperty('amministrazione')) {
          this.$set(this, 'codForn', this.codFornAdmin.UFFACQ[this.filtriRicerca.valueSelected[0]])
        }
        // Parametro: ifChangeLang = false
        this.getStatiAvanzamento(false)
      },
      getSocieta: function (ifChangeCountry) {
        this.$set(this.filtriRicerca, 'loading', true)
        this.$http.get('richiestediofferta/societa', {
          params: {
            country: this.filtriRicerca.valueSelected[0]
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              let data = response.body.data
              this.$set(this.filtriRicerca.dati, 2, data)
              this.$set(this.filtriRicerca.filtri[2], 'ifDisabled', false)
              let codSoc = this.filtriRicerca.valueSelected[2]
              if (data.length > 0 && codSoc) {
                this.getMagazzini()
              } else {
                // Se non c'è una ricerca salvata la lancio
                if (!sessionStorage.hasOwnProperty('RdO_form')) {
                  // Se NON sto cambiando stato effettuo la ricerca
                  if (!ifChangeCountry) {
                    this.cerca()
                  }
                }
                this.$emit('loadingOff')
                this.$set(this.filtriRicerca, 'loading', false)
              }
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              this.$set(this.filtriRicerca, 'loading', false)
            }
          })
      },
      /*  Al cambio della società viene richiamata la getMagazzini solo nel caso in cui si sia solo modificato il codSoc
       e non cancellato, altrimenti vengono azzerati l'array dei magazzini e il codMag
       */
      changeSocieta: function () {
        this.$set(this.filtriRicerca.valueSelected, 3, '')
        if (this.filtriRicerca.valueSelected[2]) {
          this.getMagazzini()
        } else {
          this.$set(this.filtriRicerca.dati, 3, [])
          this.$set(this.filtriRicerca.filtri[3], 'ifDisabled', true)
        }
      },
      getMagazzini: function () {
        this.$set(this.filtriRicerca, 'loading', true)
        this.$http.get('richiestediofferta/magazzini', {
          params: {
            country: this.filtriRicerca.valueSelected[0],
            codSoc: this.filtriRicerca.valueSelected[2]
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              let data = response.body.data
              this.$set(this.filtriRicerca.dati, 3, data)
              if (data.length > 0) {
                this.$set(this.filtriRicerca.filtri[3], 'ifDisabled', false)
              }
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
            this.$set(this.filtriRicerca, 'loading', false)
          })
      },
      getFornitoreInfo: function (ifChangeCountry) {
        this.$set(this.filtriRicerca, 'loading', true)
        this.$http.get('richiestediofferta/info', {
          params: {
            codLang: this.codLang,
            country: this.filtriRicerca.valueSelected[0]
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              // Se utente è FORNITORE
              if (response.body.attrib.typeOfUser !== 'admin') {
                let data = response.body.data
                this.$set(this.filtriRicerca.dati, 1, data)
                this.$set(this.filtriRicerca.filtri[1], 'ifDisabled', (data.length <= 1))
                this.$set(this.filtriRicerca.filtri[1], 'ifShow', true)

                // Se NON c'è una ricerca salvata nel sessionStorage oppure sto cambiando Stato
                if (!sessionStorage.hasOwnProperty('RdO_form') || ifChangeCountry) {
                  // Se esiste un codForn UFFACQ salvato
                  if (sessionStorage.hasOwnProperty('UFFACQ_fornitore')) {
                    let UFFACQ_fornitore = sessionStorage.getItem('UFFACQ_fornitore')
                    let flag = false
                    data.forEach((forn) => {
                      if (forn.codForn === UFFACQ_fornitore) {
                        flag = true
                        this.$set(this.filtriRicerca.valueSelected, 1, forn)
                        this.$set(this, 'codForn', forn.codForn)
                      }
                    })
                    if (!flag) {
                      this.$set(this.filtriRicerca.valueSelected, 1, data[0])
                      this.$set(this, 'codForn', data[0].codForn)
                    }
                  }
                  // Se NON esiste un codForn UFFACQ salvato
                  else {
                    this.$set(this.filtriRicerca.valueSelected, 1, data[0])
                    this.$set(this, 'codForn', data[0].codForn)
                  }
                }

                if (this.codForn) {
                  this.getSocieta(ifChangeCountry)
                } else {
                  this.$emit('loadingOff')
                  this.$set(this.filtriRicerca, 'loading', false)
                }
              }
              // Se utente è AMMINISTRATORE
              else {
                // Se esiste l'oggetto amministrazione e il codForn UFFACQ per lo Stato selezionato è valorizzato allora lo uso
                if (localStorage.hasOwnProperty('amministrazione') && this.codFornAdmin.UFFACQ[this.filtriRicerca.valueSelected[0]]) {
                  this.$set(this, 'codForn', this.codFornAdmin.UFFACQ[this.filtriRicerca.valueSelected[0]])
                }
                this.$set(this.filtriRicerca.filtri[1], 'ifShow', false)

                this.$set(this.filtriRicerca.filtri[2], 'ifDisabled', true)
                this.$set(this.filtriRicerca.filtri[3], 'ifDisabled', true)
                if (this.codForn) {
                  this.getSocieta(ifChangeCountry)
                } else {
                  this.$emit('loadingOff')
                  this.$set(this.filtriRicerca, 'loading', false)
                }
              }
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              this.$set(this.filtriRicerca, 'loading', false)
            }
            this.$set(this, 'firstLoad', false)
          })
      },
      getStatiAvanzamento: function (ifChangeLang) {
        this.$http.get('richiestediofferta/statiavanzamento', {
          params: {
            country: this.filtriRicerca.valueSelected[0]
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this.filtriRicerca.dati, 5, response.body.data)
              // Setto le traduzioni degli stati di avanzamento
              this.filtriRicerca.dati[5].forEach((stato) => {
                stato.desSt = this.$t('ricerca')[stato.codSt]
              })

              // Se NON sto cambiando lingua procedo altrimenti tolgo il loader
              if (!ifChangeLang) {
                this.getFornitoreInfo(false)
              } else {
                this.$set(this.filtriRicerca, 'loading', false)
              }
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              this.$set(this.filtriRicerca, 'loading', false)
            }
          })
      },
      changeCodForn: function () {
        this.$set(this, 'codForn', this.filtriRicerca.valueSelected[1].codForn)

        this.$set(this.filtriRicerca.dati, 2, [])
        this.$set(this.filtriRicerca.dati, 3, [])
        this.$set(this.filtriRicerca.valueSelected, 2, '')
        this.$set(this.filtriRicerca.valueSelected, 3, '')
        this.$set(this.filtriRicerca.valueSelected, 4, '')
        this.$set(this.filtriRicerca.valueSelected, 5, '')
        this.$set(this.filtriRicerca.filtri[2], 'ifDisabled', true)
        this.$set(this.filtriRicerca.filtri[3], 'ifDisabled', true)

        this.getSocieta()
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../assets/less/general.less";

   .ricerca {
    height: 100%;
    position: absolute;
    z-index: 10;
  }
</style>



// WEBPACK FOOTER //
// src/components/Fornitura/RichiesteDiOfferta/Ricerca.vue